import { render, staticRenderFns } from "./agentHaokaOrder.vue?vue&type=template&id=a55f047a&scoped=true&"
import script from "./agentHaokaOrder.vue?vue&type=script&lang=js&"
export * from "./agentHaokaOrder.vue?vue&type=script&lang=js&"
import style0 from "./agentHaokaOrder.vue?vue&type=style&index=0&id=a55f047a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55f047a",
  null
  
)

export default component.exports